/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { InHomeLocationServiceRepositoryImpl } from '../impls/InHomeLocationServiceRepositoryImpl';
import { IInHomeLocationServiceRepository } from '../interfaces/IInHomeLocationServiceRepository';
import { TInHomeLocation } from '../types/TInHomeLocation';
import { TServicesParams } from '../types/TServicesParams';

export class InHomeLocationService implements IInHomeLocationServiceRepository {
    private oInHomeLocationServiceRepository: InHomeLocationServiceRepositoryImpl;

    constructor(params: TServicesParams) {
        this.oInHomeLocationServiceRepository = new InHomeLocationServiceRepositoryImpl(params);
    }

    getInHomeLocation(): TInHomeLocation {
        return this.oInHomeLocationServiceRepository.getInHomeLocation();
    }

    async fetchAndStoreInHomeLocation(): Promise<TInHomeLocation> {
        return this.oInHomeLocationServiceRepository.fetchAndStoreInHomeLocation();
    }
}
